export default __webpack_public_path__ + "static/media/010-oval.7ef8e532.svg";